<div class="topic-panel">
  <kilden3-select-topic
    [label]="currentTopicConfig?.label"
    [topics]="topicsConfig"
    [current]="currentTopicId"
    (topicChanged)="topicChanged($event)">
  </kilden3-select-topic>
</div>
